// extracted by mini-css-extract-plugin
export default {"indicationSelectOption":"IndicationSelect_indicationSelectOption__N12IL","indicationSelectOptionLabel":"IndicationSelect_indicationSelectOptionLabel__MLfKu"};